import { FormCheck } from 'components/form/FormCheck';
import { useModal } from 'components/modal/ModalStack';
import { React } from 'libs/react';
import './StoreTermsConsent.scss';
/**
 * @function useStoreTermsModal
 * @since 1.0.0
 */
export function useStoreTermsModal() {
    const modal = useModal();
    return function openTerms(term) {
        modal.present({
            title: t('Terms and Conditions'),
            picto: 'book',
            className: 'store-terms-modal',
            modal: React.createElement(StoreTermsContent, { term: term })
        });
    };
}
/**
 * @component StoreTermsContent
 * @since 1.0.0
 * @hidden
 */
function StoreTermsContent(props) {
    var _a, _b;
    const { term } = props;
    // Mobile browsers often don't render an embedded PDF: the link stays useful.
    if ((_a = term.file) === null || _a === void 0 ? void 0 : _a.url) {
        return (React.createElement("div", { className: "store-terms-content store-terms-content--file" },
            React.createElement("embed", { src: term.file.url, width: "100%" }),
            React.createElement("a", { href: term.file.url, target: "_blank", rel: "noreferrer" }, t('Open the document'))));
    }
    return (React.createElement("div", { className: "store-terms-content store-terms-content--text", dangerouslySetInnerHTML: { __html: (_b = term.infos) !== null && _b !== void 0 ? _b : '' } }));
}
/**
 * Required before the order is placed. Sits outside .store-checkout-submit,
 * which is hidden on mobile (the sticky bar submits there).
 * @component StoreTermsConsent
 * @since 1.0.0
 */
export function StoreTermsConsent(props) {
    const { term, accepted, error, onChange } = props;
    const openTerms = useStoreTermsModal();
    return (React.createElement("div", { id: "store-terms-consent", className: "store-terms-consent" },
        React.createElement(FormCheck, { name: "termsAccepted", checked: accepted, error: error, onChange: onChange, label: React.createElement(React.Fragment, null,
                t('I have read and accept the'),
                "\u00A0",
                React.createElement("button", { type: "button", className: "store-terms-link", onClick: (event) => {
                        // Inside the label: reading the terms must not check the box.
                        event.preventDefault();
                        event.stopPropagation();
                        openTerms(term);
                    } }, t('terms and conditions'))) })));
}
